module.exports = __webpack_public_path__ + "b24e87d5/img/share-action-icon.9c12578c.svg";